import { atom } from 'jotai'

export const INITIAL_IS_GNB_OPEN = false

export const gnbOpenAtom = atom<boolean>(INITIAL_IS_GNB_OPEN)
